import React from 'react'
import { DownloadsProviderContextProps } from '../models/provider.model'

export const DownloadsProviderContext = React.createContext<DownloadsProviderContextProps | undefined>(undefined)
